export enum RegistrationStatus {
  Unauthenticated = -1,
  Invalid,
  Pending,
  Deactivated,
  Valid
}
